<app-modal>
	<div modal-header>
		<span  i18n="Modal Titel for PreRegistration@@preregister.modal.title">Interested?</span>
	</div>
	<div modal-body>
		<div class="formExplanation" i18n="Explaination for PreRegistration@preregister.modal.explain">Enter your email address to join the Closed Beta!</div>
		<platform-preregister-form></platform-preregister-form>
	</div>
</app-modal>